<template>
  <div class="dialog" v-if="isshowdialog">
    <div class="center_box">
      <div class="content">
        <div v-if="imgposition === 'top'">
          <img class="imgtop" src="@/assets/imgs/stop.png" />
          <span class="txttop"> {{infomsgMsg}} </span>
        </div>
      </div>
      <div class="content">
        <div v-if="imgposition === 'bot'">
          <span class="txtbot"> 未能通过原因 </span>
          <div class="boredbox">
            <textarea @blur="nopitchOn"></textarea>
          </div>
        </div>
      </div>
      <div v-if="isinfo" class="info_txt">*请填写原因</div>
      <div class="button" v-if="againshow">
        <button @click="dialogfunc('cancel')">{{ buttontxt[0] }}</button>
        <button
          style="background: #17B6A1; color: #fff"
          @click="dialogfunc('affirm')"
        >
          {{ buttontxt[1] }}
        </button>
      </div>
      <div class="button" v-else>
        <button
          style="background: #17B6A1; color: #fff"
          @click="dialogfunc('affirm')"
        >
          {{ buttontxt[1] }}
        </button>
        <button @click="dialogfunc('cancel')">{{ buttontxt[0] }}</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      typeof: String,
      default: "",
    },
    infomsgMsg:{
      typeof:String,
      default:"确定重置密码吗?"
    },
    isshowdialog: {
      typeof: Boolean,
      default: false,
    },
    buttontxt: {
      typeof: Array,
      default() {
        return ["取消", "确定"];
      },
    },
    imgposition: {
      typeof: String,
      default: "top",
    },
    againshow: {
      typeof: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isinfo: false,
      infomsg: "",
    };
  },
  methods: {
    dialogfunc(states) {
      if (
        states === "affirm" &&
        this.imgposition === "bot" &&
        !this.infomsg.trim()
      )
        return (this.isinfo = true);
      else this.isinfo = false;
      this.$emit("closedialog", states);
    },
    nopitchOn(event) {
      this.infomsg = event.target.value;
      this.$emit("input", event.target.value);
    },
  },
};
</script>
<style lang='scss'>
.dialog {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  z-index: 999;
  background: rgba(0, 0, 0, 0.6);
  .center_box {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    padding: 30px;
    background-color: #ffff;
    border-radius: 4px;
    .content {
      .imgtop {
        display: block;
        margin: 0 auto;
      }
      .txttop,
      .txtbot {
        display: block;
        text-align: center;
        margin: 30px auto;
        font-size: 14px;
        font-family: "Source Han Sans CN";
        font-weight: bold;
        color: #333333;
      }
      .boredbox {
        width: 250px;
        height: 200px;
        background: #f3f4f5;
        border-radius: 10px;
      }
      .txtbot {
        margin: 0;
        margin-bottom: 20px;
      }
      textarea {
        box-sizing: border-box;
        resize: none;
        font-size: 14px;
        padding: 10px;
        height: 100%;
        width: 100%;
        background-color: transparent;
        border: 0;
        outline: none;
      }
    }
    .info_txt {
      font-size: 12px;
      color: red;
    }
    .button {
      text-align: center;
      button {
        font-size: 13px;
        font-family: "Source Han Sans CN";
        font-weight: 400;
        color: #17B6A1;
        width: 80px;
        height: 30px;
        background: #f3f4f5;
        border-radius: 5px;
        border: none;
        cursor: pointer;
        margin: 20px 10px 0;
      }
    }
  }
}
</style>
